interface DataType {
  id: number;
  page: string;
  thumb: string;
  date: string;
  title: string;
  location: string;
};

const inner_event_data: DataType[] = [
  {
    id: 1,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb01.jpg",
    date: "25 June, 2024",
    title: "The Accessible Target Sizes Cheatsheet",
    location: "United Kingdom",
  },
  {
    id: 2,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb02.jpg",
    date: "25 June, 2024",
    title: "Aewe Creating Futures Through Technology",
    location: "Tokyo Japan",
  },
  {
    id: 3,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb03.jpg",
    date: "25 June, 2024",
    title: "Exactly How Technology Can Make Reading",
    location: "Colorado",
  },
  {
    id: 4,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb04.jpg",
    date: "25 June, 2024",
    title: "Learning JavaScript With Imagination",
    location: "Alexander City",
  },
  {
    id: 5,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb05.jpg",
    date: "25 June, 2024",
    title: "Make Your Magnificent May 2023 Edition",
    location: "Alaska",
  },
  {
    id: 6,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb06.jpg",
    date: "25 June, 2024",
    title: "Accessible Target Sizes Cheatsheet",
    location: "Estes Park",
  },
  {
    id: 7,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb07.jpg",
    date: "25 June, 2024",
    title: "Color mechanics that he came up with during",
    location: "Walsenburg",
  },
  {
    id: 8,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb08.jpg",
    date: "25 June, 2024",
    title: "How To Design Effective User Onboarding",
    location: "New Work",
  },
  {
    id: 9,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb07.jpg",
    date: "25 June, 2024",
    title: "Color mechanics that he came up with during",
    location: "Walsenburg",
  },
  {
    id: 10,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb08.jpg",
    date: "25 June, 2024",
    title: "How To Design Effective User Onboarding",
    location: "New Work",
  },
  {
    id: 11,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb05.jpg",
    date: "25 June, 2024",
    title: "Make Your Magnificent May 2023 Edition",
    location: "Alaska",
  },
  {
    id: 12,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb06.jpg",
    date: "25 June, 2024",
    title: "Accessible Target Sizes Cheatsheet",
    location: "Estes Park",
  },
  {
    id: 13,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb01.jpg",
    date: "25 June, 2024",
    title: "The Accessible Target Sizes Cheatsheet",
    location: "United Kingdom",
  },
  {
    id: 14,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb02.jpg",
    date: "25 June, 2024",
    title: "Aewe Creating Futures Through Technology",
    location: "Tokyo Japan",
  },
  {
    id: 15,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb03.jpg",
    date: "25 June, 2024",
    title: "Exactly How Technology Can Make Reading",
    location: "Colorado",
  },
  {
    id: 16,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb04.jpg",
    date: "25 June, 2024",
    title: "Learning JavaScript With Imagination",
    location: "Alexander City",
  },
  {
    id: 17,
    page: "inner_1",
    thumb: "/assets/img/events/event_thumb01.jpg",
    date: "25 June, 2024",
    title: "The Accessible Target Sizes Cheatsheet",
    location: "United Kingdom",
  },
];

export default inner_event_data;
